import React, { useState } from 'react';
import { ReloadStyleProps } from '../ResultScenarios';
import styles from './DemandVersusRevenueChart.module.scss';
import { ElasticCrossChart } from './ElasticCrossChart';
import { ElasticSimpleChart } from './ElasticSimpleChart';

const elasticidadeSelectData = [
  {
    label: 'Elasticidade simples',
    value: 'simples',
  },
  {
    label: 'Elasticidade cruzada',
    value: 'cruzada',
  },
];

export const DemandVersusRevenueChart = ({ styleProps }: { styleProps: ReloadStyleProps }) => {
  const [chartType, setchartType] = useState('simples');

  const handleSelectChartType = (value: string) => {
    if (value === 'simples') {
      setchartType('simples');
    } else {
      setchartType('cruzada');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles['header-wrapper']}>
        <div className={styles['title-wrapper']}>
          <p className={styles.title}>Curva de demanda vs receita</p>
          <p className={styles.subtitle}>Visualize o impacto das diferentes faixas de preço na demanda e receita</p>
        </div>
        {/* Por enquanto não teremos elasticidade cruzada */}
        {/* <SelectPicker
                    className={styles.select}
                    cleanable={false}
                    searchable={false}
                    data={elasticidadeSelectData}
                    value={chartType}
                    onSelect={handleSelectChartType}
                /> */}
      </div>
      {chartType === 'simples' ? <ElasticSimpleChart styleProps={styleProps} /> : <ElasticCrossChart />}
    </div>
  );
};
